"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Snippets = {
  tags: function tags(_a) {
    var id = _a.id;

    if (!id) {
      throw new Error('GTM ID required');
    }

    var script = "\n      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n      })(window,document,'script','dataLayer','" + id + "');\n    ";
    var noScript = "<iframe src=\"https://www.googletagmanager.com/ns.html?id=" + id + "&gtm_cookies_win=x\"\n        height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" id=\"tag-manager\"></iframe>";
    var dataLayer = 'window.dataLayer = window.dataLayer || []';
    return {
      script: script,
      noScript: noScript,
      dataLayer: dataLayer
    };
  }
};
var _default = Snippets;
exports["default"] = _default;